module.exports = __webpack_public_path__ + "static/media/renomatic.e2d917f9.jpg";